module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEfSURBVEiJzZXNTcNAEIXHPiBEDUgUkTtaCS40QBtcucW0QBepIMeFTmiC88dl5ZjJ7OxsnAie5MvOz3tv7PGK/FcACUiXapzLY2ECpnMQaOQSM897SSavUSU+O1xDMqmctJqst8ghTD1FbWWH2qxqc1hZlKTUWx/I7Gp0at96iIZh+DBqtpaifKob1ccfn5cAvADfwMPibAS+gF1E8FiCqSH0SURuROR+cbYRkTsReQauHIdpJirz9XDdiC/x6UaVZT26R2AP3Krzd+DV6XP8rnVCYJw1wbSI9B7YC+eTxBZ+jSuDpL4ihqu6qrV1hiuK2iN31O+sprga0RK5keO/2wBBBG0nhcy7zDxkTlmHQthymHsIhiDxr2aBX9bf4QdAaa89CgIKlwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact2.png
// module id = AVvM
// module chunks = 0